var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42193 41.5617V30.4947L12.3326 27.8584V41.5617H8.42193Z",
    fill: "#D4AF37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6671 41.5617V27.8584L31.5777 30.4947V41.5617H27.6671Z",
    fill: "#D4AF37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 32.3007C21.0752 32.3007 21.9554 33.1847 21.9554 34.2654V41.5617H18.0448V34.2654C18.0448 33.1847 18.9242 32.3007 19.9998 32.3007Z",
    fill: "#D4AF37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 26.2357C21.2521 26.2357 22.267 27.2558 22.267 28.514C22.267 29.7722 21.2521 30.7923 19.9998 30.7923C18.7475 30.7923 17.7326 29.7722 17.7326 28.514C17.7326 27.2556 18.7478 26.2357 19.9998 26.2357Z",
    fill: "#D4AF37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5777 22.1455L27.6673 19.5092V3.93003H12.3326V19.5092L8.42193 22.1455V1.02318C8.42193 0.459743 8.87943 0 9.44013 0C16.4798 0 23.5198 0 30.5595 0C31.1204 0 31.5777 0.459743 31.5777 1.02318V22.1455Z",
    fill: "#D4AF37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 20.8728L37.3793 32.5896C37.8452 32.9038 38.4802 32.7779 38.7923 32.3094L39.8283 30.7552C40.1404 30.2873 40.0151 29.6501 39.5497 29.3362L19.9998 16.1559L0.450195 29.3362C-0.0151878 29.6498 -0.140238 30.2871 0.171627 30.7552L1.20762 32.3094C1.51999 32.7779 2.15465 32.9038 2.62079 32.5896L19.9998 20.8728Z",
    fill: "#D9DADA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42193 43.0702H31.5777V45.9768C31.5777 46.5403 31.1204 47 30.5595 47H9.44013C8.87943 47 8.42193 46.5403 8.42193 45.9768V43.0702Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LOGO-ICON.d79f767b8b50a7df56999f5982e8f0fa.svg";
export { ForwardRef as ReactComponent };